import { render, staticRenderFns } from "./ManagePackageNav.vue?vue&type=template&id=c98de4e2"
import script from "./ManagePackageNav.vue?vue&type=script&lang=js"
export * from "./ManagePackageNav.vue?vue&type=script&lang=js"
import style0 from "./ManagePackageNav.vue?vue&type=style&index=0&id=c98de4e2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports